import gql from 'graphql-tag';

export default gql`
  mutation removeByIdCategoryMutation($_id: MongoID!) {
    removeByIdCategoryMutation(_id: $_id) {
      recordId
      message
      title
    }
  }
`;
